// The authenticated client serves only the configured API origin. Public
// providers use their own client, without the application's bearer token.
export function assertApiDestination(config, configuredBase, pageUrl) {
  function reject() {
    throw Object.assign(new Error('Destino de API não permitido.'), { code: 'UNSAFE_API_DESTINATION' });
  }
  if (typeof config.url !== 'string' || typeof configuredBase !== 'string') reject();
  try {
    const allowed = new URL(configuredBase || '/api', pageUrl);
    const base = new URL(config.baseURL || configuredBase || '/api', pageUrl);
    const destination = new URL(config.url, base);
    if (![allowed, base, destination].every(url => /^https?:$/.test(url.protocol) && !url.username && !url.password)
      || base.origin !== allowed.origin || destination.origin !== allowed.origin) reject();
  } catch (error) {
    if (error.code === 'UNSAFE_API_DESTINATION') throw error;
    reject();
  }
}
